// Additive, best-effort browser observability (OpenObserve RUM + Logs).
// This module must never throw, never block render, and must no-op when the
// client token is absent (e.g. local dev, or before the org secret exists).
import { openobserveRum } from "@openobserve/browser-rum";
import { openobserveLogs } from "@openobserve/browser-logs";

export function initRum() {
  try {
    if (typeof window === "undefined") return;

    // OPENOBSERVE_CLIENT_TOKEN is a public, write-only RUM token injected at build time.
    const clientToken = process.env.REACT_APP_OPENOBSERVE_CLIENT_TOKEN;
    if (!clientToken) return;

    const apiBaseHost = (() => {
      try {
        return window.location.hostname;
      } catch (e) {
        return "";
      }
    })();

    const allowedTracingUrls = [
      (url) => {
        try {
          const parsed = new URL(url, window.location.href);
          return (
            parsed.hostname === apiBaseHost ||
            parsed.hostname.endsWith(".incruiter.com") ||
            parsed.hostname === "incruiter.com"
          );
        } catch (e) {
          return false;
        }
      },
    ];

    const sharedConfig = {
      applicationId: "frontend-admin",
      service: "frontend-admin",
      clientToken,
      site: "monitor.incruiter.com",
      organizationIdentifier: "default",
      env: "development",
      version: "0.0.1",
      insecureHTTP: false,
      apiVersion: "v1",
    };

    openobserveRum.init({
      ...sharedConfig,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      defaultPrivacyLevel: "mask",
      allowedTracingUrls,
      propagatorTypes: ["tracecontext", "openobserve"],
    });

    openobserveRum.startSessionReplayRecording();

    openobserveLogs.init({
      ...sharedConfig,
      forwardErrorsToLogs: true,
    });
  } catch (e) {
    // Observability must never break the app.
    console.warn("[rum] initRum failed to initialize", e);
  }
}
